import script from "./accAuthNoticeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./accAuthNoticeModal.vue?vue&type=script&setup=true&lang=js"

import "./accAuthNoticeModal.vue?vue&type=style&index=0&id=51c90c00&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c90c00"]])

export default __exports__